enum Genders {
  Male,
  Female,
  Other,
}

export default Genders;
